export default __webpack_public_path__ + "static/media/flavia.6151f709.jpg";